export default "__VITE_ASSET__BOARXTql__"